// extracted by mini-css-extract-plugin
export default {"spinner":"FileUploadingModal_spinner__PFHIB"};